<template>
	<div>
		<growth-10k :widget-data="widgetData" @open-modal="openModal">
			<template #Iball_primaryIndex1a>
				<i-ball-modal :tag="primaryIndex" />
			</template>
			<template #Iball_primaryIndex1b>
				<i-ball-modal :tag="primaryIndex" />
			</template>
			<template #Iball_primaryIndex1c>
				<i-ball-modal :tag="primaryIndex" />
			</template>
			<template #Iball_primaryIndex1d>
				<i-ball-modal :tag="primaryIndex" />
			</template>
			<template #superscript1a>
				<disclosure-superscript
					class="detail-page"
					anchor="growth10K_index"
					:statistics="[primaryIndex]"
				/>
			</template>
			<template #superscript1b>
				<disclosure-superscript
					class="detail-page"
					anchor="growth10K_index"
					:statistics="[primaryIndex]"
				/>
			</template>
			<template #superscript1c>
				<disclosure-superscript
					class="detail-page"
					anchor="growth10K_index"
					:statistics="[primaryIndex]"
				/>
			</template>
			<template #superscript1d>
				<disclosure-superscript
					class="detail-page"
					anchor="growth10K_index"
					:statistics="[primaryIndex]"
				/>
			</template>
			<template #superscript2>
				<disclosure-superscript
					class="detail-page"
					anchor="growth10K_tab"
					:statistics="['NAVAvgLifetime ']"
				/>
			</template>
			<template #superscript3>
				<disclosure-superscript
					class="detail-page"
					anchor="growth10K_tab"
					:statistics="['NAVAvgLifetime ']"
				/>
			</template>
		</growth-10k>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Growth10k from './growth-10k/Growth10k.vue';

export default {
	name: 'Growth10kWrapper',
	components: {
		Growth10k
	},
	computed: {
		...mapGetters([
			'getFundAttributes',
			'getFundInfoData',
			'growth10kData'
		]),
		widgetData() {
			const data = this.growth10kData;
			if (data && this.getFundAttributes) {
				data.shareClass = this.getFundAttributes.ShareClass;
				data.fundSymbol = this.getFundAttributes.FundSymbol;
				data.indexName =
					this.getFundInfoData && this.getFundInfoData.cgIndexName;
			}
			return data;
		},
		primaryIndex() {
			return (
				(this.getFundInfoData && `${this.getFundInfoData.cgIndexID}`) ||
				''
			);
		}
	},
	methods: {
		openModal() {
			const modal = { showModal: true, activeTab: 'growth' };
			this.$store.commit('displayModal', modal);
		}
	}
};
</script>